import { classNameMerger } from '@breetometer/utils';
import { DropdownCaretIcon } from 'BreetAssets';
import { ImageComponent } from 'BreetComponents';

import type { ModernDropdownControlProps } from '../../Dropdown.helpers';

export const ModernDropDownControl = ({
	selectedItem,
	buttonRef,
	handleVisibility,
	visible,
	isLabel,
	disabled,
}: ModernDropdownControlProps) => {
	const openClass = visible ? ' open' : '';
	const validClass = selectedItem?.value ? ' valid' : '';
	const labelClass = !isLabel ? ' no-label' : '';

	const buttonClass = `dropdown_content_control modern-dropdown_control${openClass}${validClass}${labelClass}`;

	return (
		<button
			onClick={disabled ? undefined : handleVisibility}
			className={buttonClass}
			ref={buttonRef}
			type='button'
			aria-expanded={visible}
			disabled={disabled}
		>
			{!!selectedItem?.icon && (
				<span className='modern-dropdown_control_icon'>
					{typeof selectedItem.icon === 'string' ? (
						<ImageComponent
							src={selectedItem.icon}
							alt=''
						/>
					) : (
						selectedItem.icon
					)}
				</span>
			)}

			{!!selectedItem?.name && <span className='modern-dropdown_control_value'>{selectedItem.name}</span>}

			{!disabled && <DropdownCaretIcon className={classNameMerger('modern-dropdown_control_caret', visible && 'open')} />}
		</button>
	);
};
